import { Routes } from '../constants/routes';

export const tabs = [
  {
    label: 'Your NFTs',
    url: Routes.YOUR_NFTS,
  },
  {
    label: 'Open Swaps',
    url: Routes.OPEN_SWAPS,
  },
  {
    label: 'Recent Swaps',
    url: Routes.RECENT_SWAPS,
  },
];
